import { render, staticRenderFns } from "./resources-preloader.vue?vue&type=template&id=1c038ca7&scoped=true"
var script = {}
import style0 from "./resources-preloader.vue?vue&type=style&index=0&id=1c038ca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c038ca7",
  null
  
)

export default component.exports